document.addEventListener('easysearch_init', event => {
  const collectionUrlHandleCheckerNATIVE = easysearch.collectionUrlHandleChecker.bind(easysearch);
  easysearch.collectionUrlHandleChecker = function(a) {
    let url = collectionUrlHandleCheckerNATIVE(a);

    const newUrlDetails     = new URL(url, window.location.origin);
    const currentUrlDetails = new URL(window.location.href);
    if( newUrlDetails.pathname === '/collections/vendors'  ) {
      const q = currentUrlDetails.searchParams.get('q');
      if( q ) {
        newUrlDetails.searchParams.set('q', q);
        url = newUrlDetails.pathname + newUrlDetails.search;
      }
    }

    return url;
  }
});